export const FETCH_TEXT_INFO = "FETCH_TEXT_INFO"
export const FETCH_TEXT_INFO_SUCCESS = "FETCH_TEXT_INFO_SUCCESS"

